export const kgToLb = (kg) => kg * 2.20462;
export const lbToKg = (lb) => lb / 2.20462;
export const cmToFtIn = (cm) => { const total = Math.round(cm / 2.54); return { ft: Math.floor(total / 12), in: total % 12 }; };
export const ftInToCm = (ft, inch) => (Number(ft || 0) * 12 + Number(inch || 0)) * 2.54;
export const fmtWeight = (kg, units, digits = 1) => kg == null ? "—" : units === "us" ? `${Math.round(kgToLb(kg))} lb` : `${Number(kg).toFixed(digits)} kg`;
export const fmtDelta = (kg, units) => { if (!kg) return "±0"; const v = units === "us" ? Math.round(kgToLb(kg)) : Number(kg).toFixed(1); return `${kg > 0 ? "+" : ""}${v} ${units === "us" ? "lb" : "kg"}`; };
export const toKg = (value, units) => (units === "us" ? lbToKg(Number(value)) : Number(value));
export const fromKg = (kg, units) => (units === "us" ? Math.round(kgToLb(kg)) : Math.round(kg * 10) / 10);
export const isoWeek = (d = new Date()) => {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
  return `${date.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
};
export const today = () => new Date().toISOString().slice(0, 10);
